import { Box, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import classes from "./HTMLReportViewer.module.css";

export default function ChatMessage({ message }) {
  const { role, type, text } = message;

  // ── User bubble ─────────────────────────────────────────────────────────────
  if (role === "user") {
    return (
      <Box className={classes.msgUser}>
        <Typography className={classes.msgUserText}>{text}</Typography>
      </Box>
    );
  }

  // ── AI: thinking skeleton ───────────────────────────────────────────────────
  if (type === "thinking") {
    const { chunkCount = 0 } = message;
    return (
      <Box className={classes.msgAiRow}>
        <Box className={classes.msgAiAvatar}>
          <AutoAwesomeIcon sx={{ fontSize: 13, color: "#7c3aed" }} />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Box className={classes.thinkingDots}>
            <span className={classes.dot} />
            <span className={classes.dot} />
            <span className={classes.dot} />
          </Box>
          {chunkCount > 0 && (
            <Typography sx={{ fontSize: 10, color: "#9ca3af" }}>
              Generating… {chunkCount} chunks received
            </Typography>
          )}
        </Box>
      </Box>
    );
  }

  // ── AI: done ────────────────────────────────────────────────────────────────
  if (type === "done") {
    const { failures = [] } = message;
    const hasFailures = failures.length > 0;
    return (
      <Box className={classes.msgAiRow}>
        <Box className={classes.msgAiAvatar}>
          <CheckCircleOutlineIcon sx={{ fontSize: 13, color: hasFailures ? "#f59e0b" : "#2ed4a1" }} />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography className={classes.msgAiText} sx={{ whiteSpace: "pre-line" }}>
            {text || "Done! Review the preview above, then save when ready."}
          </Typography>
          {hasFailures && (
            <Typography sx={{ fontSize: 10, color: "#f59e0b" }}>
              ⚠ {failures.length} change(s) could not be matched in the HTML — try rephrasing your request.
            </Typography>
          )}
        </Box>
      </Box>
    );
  }

  // ── AI: error ───────────────────────────────────────────────────────────────
  if (type === "error") {
    return (
      <Box className={classes.msgAiRow}>
        <Box className={classes.msgAiAvatar}>
          <ErrorOutlineIcon sx={{ fontSize: 13, color: "#ef4444" }} />
        </Box>
        <Typography className={classes.msgAiText} sx={{ color: "#ef4444" }}>
          {text}
        </Typography>
      </Box>
    );
  }

  return null;
}
